module.exports = __webpack_public_path__ + "img/1507744769.6fcd616a.jpg";